import React from 'react'
import {Editor, IAllProps} from '@tinymce/tinymce-react/lib/cjs/main/ts'
import {EnterKeyHandlerProps, withEnterKeyHandler} from './hoc/withEnterKeyHandler'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {isIOS, isMobile, isTablet} from 'react-device-detect'
import styled from 'styled-components'

const PPHtmlEditor: React.FC<IAllProps & ErrorHandlingFormProps & EnterKeyHandlerProps> = props => {
    const {init, hasError, messages, onKeyPress, clearErrorMessage, eventKeys, eventEmitter, ...rest} = props
    return <WrappedEditor>
        <Editor
            {...rest}
            init={{
                menubar: false,
                statusbar: false,
                plugins: 'link',
                toolbar: 'undo redo | bold underline strikethrough | forecolor link',
                width: '100%',
                language: 'ja',
                paste_as_text: true,
                force_br_newlines: true,
                force_p_newlines: false,
                forced_root_block : 'div',
                link_title: false,
                link_target_list: false,
                link_default_target: '_blank',
                ...init,
            }}
        />
    </WrappedEditor>
}
PPHtmlEditor.displayName = 'PPHtmlEditor'

export default createErrorHandlingForm(withEnterKeyHandler(PPHtmlEditor))

const WrappedEditor = styled.div`
  ${!isMobile && 'width: 100%'};
  ${isTablet && 'width: 100%'};
  ${isIOS && 'width: 100%'};
`;
